import {sessionStore, type SessionOwner} from "../../shared/session/session-store";
import type {AccountDeletionResult} from "./model";

export interface DeletionAttempt {
  readonly operationId: string;
  readonly owner: SessionOwner;
  readonly sending: boolean;
  readonly result?: AccountDeletionResult;
  readonly error?: unknown;
}
let current: DeletionAttempt | undefined;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((listener) => listener());
export const deletionFlow = {
  snapshot: () => current,
  subscribe(listener: () => void): () => void { listeners.add(listener); return () => { listeners.delete(listener); }; },
  begin(owner: SessionOwner, operationId: string, send: () => Promise<AccountDeletionResult>): void {
    if (current?.sending) return;
    const attempt: DeletionAttempt = {owner,operationId,sending:true};
    current = attempt; emit();
    void send().then((result) => {
      if (current !== attempt) return;
      current = {...attempt,sending:false,result};
      this.accept(result);
      emit();
    }, (error: unknown) => {
      if (current !== attempt) return;
      current = {...attempt,sending:false,error}; emit();
    });
  },
  accept(result: AccountDeletionResult): void {
    if (current && current.operationId !== result.operationId) return;
    if (result.state === "anonymized" && current && sessionStore.isCurrentOwner(current.owner)) sessionStore.clear();
  },
};
